export default "data:video/mp2t;base64,aW1wb3J0IGFyY1RpdGFuIGZyb20gIi4vYXJjVGl0YW4iOwoKZXhwb3J0IGRlZmF1bHQgewogIGFyY1RpdGFuLAp9Owo="